/* eslint-disable */
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_ORDER_TRUCK_SIZE_SELECTOR } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * TruckSizeSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const TruckSizeSelector = ({ actions, classes, onChange = () => {}, defaultTruckSize, disabled }) => {
  const [truckSize, setTruckSize] = useState(defaultTruckSize || `any`);
  const truckSizeCodes = {
    any: `Any Truck Size`,
    '8A': `8-Wheeler max`,
    '6A': `6-Wheeler max`,
    MA: `Mini only`,
  };

  /**
   * Sets order status and informs parent about changes
   * @param {Object} e event
   * @returns {void} void
   */
  const onTruckSizeHandle = (e) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `orderTruckSizeSelector`,
        },
      },
      type: UI_ORDER_TRUCK_SIZE_SELECTOR,
    });
    setTruckSize(e.target.value);
    onChange({ isValid: true, selectedTruckSize: e.target.value, selectedTruckSizeName: truckSizeCodes[e.target.value] });
    e.preventDefault();
    return;
  };

  return (
    <FormControl fullWidth className={classes.formControl}>
      <InputLabel id="truck-size">Max Truck Size</InputLabel>
      <Select fullWidth value={truckSize} onChange={onTruckSizeHandle} className={classes.selectEmpty} disabled={disabled}>
        <MenuItem value="any">Any Truck Size</MenuItem>
        <MenuItem value="8A">8-Wheeler max</MenuItem>
        <MenuItem value="6A">6-Wheeler max</MenuItem>
        <MenuItem value="MA">Mini only</MenuItem>
      </Select>
      {!disabled && <FormHelperText>Select the maximum truck size that can access your site</FormHelperText>}
    </FormControl>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
TruckSizeSelector.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  defaultTruckSize: PropTypes.string,
  disabled: PropTypes.bool,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(TruckSizeSelector);
